import { render, staticRenderFns } from "./tuitionAndDorm.vue?vue&type=template&id=0b8a7b5e&scoped=true&"
import script from "./tuitionAndDorm.vue?vue&type=script&lang=js&"
export * from "./tuitionAndDorm.vue?vue&type=script&lang=js&"
import style0 from "./tuitionAndDorm.vue?vue&type=style&index=0&id=0b8a7b5e&scoped=true&lang=scss&"
import style1 from "./tuitionAndDorm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8a7b5e",
  null
  
)

export default component.exports